import { useEffect, useState } from 'react';
import {
  useParams,
  useLocation,
  useNavigate,
  generatePath,
} from 'react-router-dom';
import {
  ButtonPseudo,
  IconBack,
  SidePanel,
  SidePanelType,
  formatDate,
  IconAttention,
  ButtonSecondary,
} from '@ui/src';
import { useAppDispatch, useAppSelector } from '@store';
import {
  getCardTransaction,
  clearCardTransactionState,
} from '../store/slices/accounts-statements';
import CardTransaction from '../../../components/partial/suspicious-transaction/card-transaction';
import { CardTransaction as CardTransactionProps } from '../types';

import cn from '../customers.module.css';

const CardTransactionHOC = ({
  backPath,
}: {
  backPath: string;
}): React.JSX.Element => {
  const [panelIsOpen, setPanelIsOpen] = useState(false);
  const { transaction, isLoading } = useAppSelector(
    (state) => state.customerAccountsStatements.cardTransaction,
  );

  const { customerId, transactionId } = useParams();
  const { search } = useLocation();
  const navigate = useNavigate();

  const dispatch = useAppDispatch();

  const handleClose = () => {
    setPanelIsOpen(false);

    setTimeout(() => {
      navigate(
        generatePath(`${backPath}${search || ''}`, {
          customerId,
        }),
      );
    }, 100);
  };

  useEffect(() => {
    setPanelIsOpen(true);

    return () => {
      dispatch(clearCardTransactionState());
    };
  }, [dispatch]);

  useEffect(() => {
    if (customerId && !transaction && transactionId) {
      dispatch(getCardTransaction(transactionId));
    }
  }, [dispatch, customerId, transaction, transactionId]);

  return (
    <SidePanel
      type={SidePanelType.Cards}
      closeOnClickOutside
      isOpen={panelIsOpen}
      onClose={handleClose}
      sidepanelExpandedKey="customers-card-transaction"
      title={
        <div className={cn.cardTransactionTitleWrapper}>
          <span className={cn.cardTransactionTitle}>
            {!isLoading ? formatDate(transaction?.date as string, true) : ''}
          </span>
          {transaction?.transaction === 'warning' && (
            <IconAttention className={cn.cardTransactionTitleIcon} />
          )}
        </div>
      }
      footer={
        <>
          <ButtonSecondary
            className={`button-white ${cn.buttonChargeback}`}
            text="Chargeback"
            icon={<IconBack />}
            bold
          />
          <ButtonPseudo
            className={`button-white button-warning ${cn.buttonFraud}`}
            text="Fraud"
            icon={<IconAttention />}
            bold
          />
        </>
      }
    >
      <CardTransaction
        isLoading={isLoading}
        transaction={transaction as CardTransactionProps}
      />
    </SidePanel>
  );
};

export default CardTransactionHOC;
